import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  expand(): void {
    this.#callOnAllExpandableBoxes(el => {
      el.setAttribute('open', '')
    })
  }

  collapse(): void {
    this.#callOnAllExpandableBoxes(el => {
      el.removeAttribute('open')
    })
  }

  #callOnAllExpandableBoxes(callback: (el: HTMLDetailsElement) => void): void {
    document.querySelectorAll('details').forEach(el => {
      callback(el)
    })
  }
}
